import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=3e3dab54&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=3e3dab54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3dab54",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuItem: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/MenuItem.vue').default})
